import { z } from 'zod';
import { Products } from '../events';
export var GetWorkspacesForAccountRequestDtoSchema = z.object({
    product: z.nativeEnum(Products).nullish(),
});
